import type { Correlations } from "@/composables/forms/formTypes";
import type { DeviationSurveyEntryRows } from "@/composables/scenarioCalculations/calculationTypes";
import type { FluidPropertiesContext } from "@/libs/calculations/fluidProperties/d";
import type { PipeFrictionProperties } from "@/libs/calculations/tubingFrictionLoss";
import type { CasingIntervalGeometry } from "./types";
import { computeCasingFrictionPropertiesAcrossEquipmentIntervalUpward } from "./intervals";

export function computeCasingPressurePropertiesBetweenSensorAndMotor(
  correlations: Correlations | null | undefined,
  bottomOfSensorMDFt: number,
  bottomOfSensorTVDFt: number,
  bottomOfMotorMDFt: number,
  bottomOfMotorTVDFt: number,
  entryRows: DeviationSurveyEntryRows,
  fluidPropertiesContext: FluidPropertiesContext,
  surfaceTemperatureF: number,
  bottomholeTemperatureF: number,
  intervalCasingGeometry: CasingIntervalGeometry,
  bottomCasingPressurePSIA: number,
  producingBottomholePressurePSIA: number
): PipeFrictionProperties {
  return computeCasingFrictionPropertiesAcrossEquipmentIntervalUpward({
    correlations,
    startMDFt: bottomOfSensorMDFt,
    endMDFt: bottomOfMotorMDFt,
    entryRows,
    fluidPropertiesContext,
    surfaceTemperatureF,
    bottomholeTemperatureF,
    intervalCasingGeometry,
    bottomCasingPressurePSIA,
    producingBottomholePressurePSIA
  });
}

export function computeCasingPressurePropertiesBetweenMotorAndSeals(
  correlations: Correlations | null | undefined,
  bottomOfMotorMDFt: number,
  bottomOfMotorTVDFt: number,
  bottomOfSealsMDFt: number,
  bottomOfSealsTVDFt: number,
  entryRows: DeviationSurveyEntryRows,
  fluidPropertiesContext: FluidPropertiesContext,
  surfaceTemperatureF: number,
  bottomholeTemperatureF: number,
  intervalCasingGeometry: CasingIntervalGeometry,
  bottomCasingPressurePSIA: number,
  producingBottomholePressurePSIA: number
): PipeFrictionProperties {
  return computeCasingFrictionPropertiesAcrossEquipmentIntervalUpward({
    correlations,
    startMDFt: bottomOfMotorMDFt,
    endMDFt: bottomOfSealsMDFt,
    entryRows,
    fluidPropertiesContext,
    surfaceTemperatureF,
    bottomholeTemperatureF,
    intervalCasingGeometry,
    bottomCasingPressurePSIA,
    producingBottomholePressurePSIA
  });
}

export function computeCasingPressurePropertiesBetweenSealsAndIntakes(
  correlations: Correlations | null | undefined,
  bottomOfSealsMDFt: number,
  bottomOfSealsTVDFt: number,
  bottomOfIntakesMDFt: number,
  bottomOfIntakesTVDFt: number,
  entryRows: DeviationSurveyEntryRows,
  fluidPropertiesContext: FluidPropertiesContext,
  surfaceTemperatureF: number,
  bottomholeTemperatureF: number,
  intervalCasingGeometry: CasingIntervalGeometry,
  bottomCasingPressurePSIA: number,
  producingBottomholePressurePSIA: number
): PipeFrictionProperties {
  return computeCasingFrictionPropertiesAcrossEquipmentIntervalUpward({
    correlations,
    startMDFt: bottomOfSealsMDFt,
    endMDFt: bottomOfIntakesMDFt,
    entryRows,
    fluidPropertiesContext,
    surfaceTemperatureF,
    bottomholeTemperatureF,
    intervalCasingGeometry,
    bottomCasingPressurePSIA,
    producingBottomholePressurePSIA
  });
}
